var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_515_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2218 9.02648L40.4056 1.41274C37.9884 -0.676648 34.495 -0.417563 32.4586 2.00613L2.17714 38.0606C0.148999 40.476 0.347674 44.0029 2.62416 46.0922L11.192 54.0821L11.3079 54.174C23.601 64.7881 42.1192 63.2837 52.591 50.8226C63.0298 38.3866 61.5232 19.6322 49.2301 9.01812L49.2218 9.02648ZM18.7914 45.4404L14.3212 41.3368L37.3758 13.8906L41.8791 17.7852C49.4122 24.2874 50.3394 35.7707 43.9569 43.376C37.5662 50.9814 26.2583 51.9007 18.7914 45.4487V45.4404Z",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3924 24.1366C41.9785 23.1002 40.9934 22.4316 39.8841 22.4316C39.5282 22.4316 39.1888 22.4985 38.8576 22.6406C38.1871 22.9164 37.6656 23.4429 37.3924 24.1199C37.1109 24.7968 37.111 25.5407 37.3841 26.2176C38.75 29.6191 38.154 33.472 35.8361 36.2801C33.9818 38.5199 31.2749 39.7986 28.3858 39.7986C27.7566 39.7986 27.1275 39.7318 26.5066 39.6148C26.3328 39.5814 26.159 39.5646 25.9851 39.5646C24.6937 39.5646 23.5762 40.4923 23.3278 41.7794C23.0381 43.267 23.9984 44.7129 25.4636 45.0054C26.4239 45.1976 27.409 45.2896 28.3858 45.2896C32.8725 45.2896 37.1027 43.2921 39.9835 39.807C43.601 35.436 44.5282 29.4353 42.4007 24.1366H42.3924Z",
    fill: "#DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_515_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 92,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuImg);
export default __webpack_public_path__ + "static/media/menu_img.395ebbc2de439976f476e93397ead71b.svg";
export { ForwardRef as ReactComponent };